import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import API from "../../api";
import { fetchProduct } from "../../redux/slices/productSlice";
import { fetchContent } from "../../redux/slices/contentSlice";
import { useNavigate } from "react-router-dom";

const ProductFamilies = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = useSelector((state) => state.lang.lang);
  const { dataProduct } = useSelector((state) => state.product);
  const { dataContent } = useSelector((state) => state.content);
  useEffect(() => {
    dispatch(fetchProduct());
    dispatch(fetchContent());
  }, [dispatch]);
  // Ürünleri sıralama
  const sortedProducts = Array.isArray(dataProduct)
    ? [...dataProduct].sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
    : [];
  let product_families_url = "";
  let product_families = "";
  let see_all_products = "";
  if (dataContent) {
    product_families_url = dataContent.specialField1?.[lang] || "";
    product_families = dataContent.specialField4?.[lang] || "";
    see_all_products = dataContent.showcaseText3?.[lang] || "";
  }

  const handleProductClick = (slug, id) => {
    navigate(`/urun-aileleri/${slug}`, {
      state: { productId: id, scrollToProduct: true },
      replace: false,
    });
  };

  return (
    <div className="product-families">
      <div className="d-flex justify-content-between align-items-center mb48">
        <div>
          <strong className="f20 fw600 color1">{product_families}</strong>
        </div>
        <Link to={product_families_url} className="text-decoration-none">
          <div className="d-flex justify-content-start align-items-center">
            <div>
              <span className="f18 fw500 color1">{see_all_products}</span>
            </div>
            <div className="ml-3">
              <FaArrowRight className="w32 p-2 h32 br16 bg2" color="white" />
            </div>
          </div>
        </Link>
      </div>
      <Row className="product-families-content justify-content-center">
        {sortedProducts.map((item) => (
          <Col
            key={item.id}
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            className="mb-4"
          >
            <div
              onClick={() => handleProductClick(item.slug[lang], item.id)}
              className="text-decoration-none cursor-pointer"
              style={{ cursor: "pointer" }}
            >
              <div className="product-family-item">
                {item.files && item.files.length > 0 ? (
                  <img
                    src={`${API.BASE}${item.files[0]}`}
                    alt={item.title[lang]}
                  />
                ) : (
                  <div className="placeholder-image" />
                )}
                <span className="f20">{item.title[lang]}</span>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ProductFamilies;
